export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img className="animate" src="https://cdn.pixabay.com/photo/2019/10/09/07/28/development-4536630_960_720.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
          I pursued my master's degree in Computer Science from University of Lincoln, United Kingdom and availed myself for services. As an experienced software engineer and programmer, I am able to able to understand problems clearly, break them down into hypotheses, and propose solutions in a coherent manner. I can understand concepts quickly, or ask the right questions to help make everything clear, and don't need to have everything written down in a specifications document. I rate myself very good in Researching, designing, implementing, and managing software programs.
          </p>
        </div>
      </div>
    </section>
  );
}
